// combineErrorList

import {forOwn, isString} from 'lodash';
import {FieldErrors} from 'react-hook-form';

type ErrMessage = FieldErrors<any>; //{message?: string};
export type ErrorMessageOut = {message: string; name: string};
export function combineYupErrorsMessages(
   list: ErrorMessageOut[],
   errors: ErrMessage,
   keyChain: string
) {
   if ((errors as ErrMessage)?.type && isString((errors as ErrMessage)?.message)) {
      list.push({
         message: String((errors as ErrMessage).message || (errors as ErrMessage).type),
         name: keyChain,
      });
      return;
   }
   forOwn(errors, (e, key) =>
      combineYupErrorsMessages(list, e as ErrMessage, keyChain ? `${keyChain}.${key}` : key)
   );
}
